import http from "../jslibs/axios/http";

// 课程列表
export const getCouseList = (data) => http.get("/v1/cms/course", data);
// 添加
export const addCouse = (data) => http.post("/v1/cms/course", data);
// 编辑课程
export const editCouse = (data, uuid) => http.put(`/v1/cms/course/${uuid}`, data);
// 删除课程
export const delCouse = (uuid) => http.delete(`/v1/cms/course/${uuid}`);
// 课程详情
export const couseDetail = (uuid) => http.get(`/v1/cms/course/${uuid}`);
// 课程上架下架
export const couseStatus = (uuid) => http.get(`/v1/cms/CourseStatus/${uuid}`);
// 课程推不推荐
export const couseTop = (uuid) => http.get(`/v1/cms/CourseTop/${uuid}`);

// 其它条件列表
export const conditionList = (data) => http.get("/v1/cms/problem", data);
// 新建其它条件
export const addCondition = (data) => http.post("/v1/cms/problem", data);
// 编辑其它条件
export const editCondition = (data, uuid) => http.put(`/v1/cms/problem/${uuid}`, data);
// 其它条件详情
export const conditionDetail = (uuid) => http.get(`/v1/cms/problem/${uuid}`);
// 删除其它条件
export const delCondition = (uuid) => http.delete(`/v1/cms/problem/${uuid}`);

// 课节列表
export const sectionList = (data) => http.get("/v1/cms/section", data);
// 新建课节
export const addSection = (data) => http.post("/v1/cms/section", data);
// 编辑课节
export const editSection = (data, uuid) => http.put(`/v1/cms/section/${uuid}`, data);
// 删除课节
export const delSection = (uuid) => http.delete(`/v1/cms/section/${uuid}`);
// 课节详情
export const sectionDetail = (uuid) => http.get(`/v1/cms/section/${uuid}`);

// 考试
// 考试列表
export const paperList = (data) => http.get("/v1/cms/paper", data);
// 新建考试
export const addPaper = (data) => http.post("/v1/cms/paper", data);
// 编辑考试
export const editPaper = (data, uuid) => http.put(`/v1/cms/paper/${uuid}`, data);
// 删除考试
export const delPaper = (uuid) => http.delete(`/v1/cms/paper/${uuid}`);
// 考试详情
export const paperDetail = (uuid) => http.get(`/v1/cms/paper/${uuid}`);
// 考试展示
export const paperStatus = (uuid) => http.get(`/v1/cms/PaperStatus/${uuid}`);

// 题目
// 题目列表
export const subjectList = (data) => http.get("/v1/cms/subject", data);
// 新建题目
export const addSubject = (data) => http.post("/v1/cms/subject", data);
// 编辑题目
export const editSubject = (data, uuid) => http.put(`/v1/cms/subject/${uuid}`, data);
// 删除题目
export const delSubject = (uuid) => http.delete(`/v1/cms/subject/${uuid}`);
// 导入题目
export const importSubject = (data) => http.fileUp(`/v1/cms/SubjectImport`, data);
// 题目详情
export const subjectDetail = (uuid) => http.get(`/v1/cms/subject/${uuid}`);
// 填写记录
export const TotalScore = (data) => http.get(`/v1/cms/TotalScore`, data);
// 填写记录详情
export const TotalScoreDetail = (uuid, data) => http.get(`/v1/cms/TotalScore/${uuid}`, data);
// 线下评分
export const offLineScore = (data) => http.post("/v1/cms/Exam", data);
// 线上评分
export const onlineScore = (data, uuid) => http.put(`/v1/cms/ReceiverSubject/${uuid}`, data);
// 评分详情
export const offLineScoreDetail = (total_uuid) => http.get(`/v1/cms/Exam/${total_uuid}`);
// 删除
export const delScoreDetail = (uuid) => http.delete(`/v1/cms/TotalScore/${uuid}`);

// 下载填写记录
export const exportScoreDetail = (data) => http.down("/v1/cms/TotalScoreExport", data);

// 证书
// 证书列表
export const certificateList = (data) => http.get("/v1/cms/certificate", data);
// 新建证书
export const addCertificate = (data) => http.post("/v1/cms/certificate", data);
// 编辑证书
export const editCertificate = (data, uuid) => http.put(`/v1/cms/certificate/${uuid}`, data);
// 删除证书
export const delCertificate = (uuid) => http.delete(`/v1/cms/certificate/${uuid}`);
// 证书详情
export const certificateDetail = (uuid) => http.get(`/v1/cms/certificate/${uuid}`);
// 证书
// 发放名单
export const certificateUser = (data) => http.get("/v1/cms/UserCertificate", data);
// 添加发放名单
export const certificateUserAdd = (data) => http.post("/v1/cms/UserCertificate", data);
// 批量导入
export const UserCertificateImport = (data) => http.fileUp("/v1/cms/UserCertificateImport", data);
// 删除名单
export const delCertificateUser = (uuid) => http.delete(`/v1/cms/UserCertificate/${uuid}`);
// 证书模板
export const CertificateTemplate = (data) => http.down("/v1/cms/CertificateTemplate", data);

// 补课申请
// 补课列表
export const markupList = (data) => http.get("/v1/cms/CourseSubscribe", data);
// 操作
export const editMskeup = (data, uuid) => http.put(`/v1/cms/CourseSubscribe/${uuid}`, data);

// 签到列表
export const signList = (data) => http.get("/v1/cms/ArchiveSign", data);
// 导出签到列表
export const exportSign = (data) => http.down("/v1/cms/ArchiveSignExport", data);
// 签到详情
export const signDetail = (data) => http.get(`/v1/cms/CourseSign`, data);
// 删除签到
export const delSign = (id) => http.delete(`/v1/cms/CourseSign/${id}`);
// 安排补课
export const makeUpsign = (data) => http.post(`/v1/cms/CourseSign`, data);
// 获取补课列表
export const makeupTimeList = (section_uuid, data) => http.get(`/v1/cms/CourseSign/${section_uuid}`, data);

// 批量导入学生成绩
export const UserScoreImport = (data) => http.fileUp("/v1/cms/ScoreImport", data);
// 批量导入报名信息
export const CourseOrderImport = (data) => http.fileUp("/v1/cms/CourseOrderImport", data);
// 新建分类
export const addPaperCate = (data) => http.post("/v1/cms/PaperCate", data);
// 编辑分类
export const editPaperCate = (data, uuid) => http.put(`/v1/cms/PaperCate/${uuid}`, data);
// 删除分类
export const delPaperCate = (uuid) => http.delete(`/v1/cms/PaperCate/${uuid}`);

// 证书列表
export const paperCateList = (data) => http.get("/v1/cms/PaperCate", data);
// 证书详情
export const paperCateDetail = (uuid) => http.get(`/v1/cms/PaperCate/${uuid}`);

// 新建题目-题库
export const addPaperSubject = (data) => http.post("/v1/cms/PaperSubject", data);
// 题目列表
export const paperSubjectList = (data) => http.get("/v1/cms/PaperSubject", data);
export const delPaperSubject = (uuid) => http.delete(`/v1/cms/PaperSubject/${uuid}`);

export const exportStu = (data) => http.down("/v1/cms/ArchiveExport", data);
export const exportLearn = (data) => http.down("/v1/cms/LearnReport", data);

// 考卷科目
// 列表
export const subjectTipList = (data) => http.get("/v1/cms/subjectTip", data);
// 新建
export const addSubjectTip = (data) => http.post("/v1/cms/subjectTip", data);
// 编辑
export const editSubjectTip = (data, uuid) => http.put(`/v1/cms/subjectTip/${uuid}`, data);
// 删除
export const delSubjectTip = (uuid) => http.delete(`/v1/cms/subjectTip/${uuid}`);
// 导入
export const importSubjectTip = (data) => http.fileUp(`/v1/cms/SubjectTipImport`, data);

// 考试绑定科目
// 获取试卷关联科目
export const getExamSubjectList = (data) => http.post("/v1/cms/PaperSubject/subject_tips", data);
// 试卷绑定科目
export const bindExamSubject = (data) => http.post("/v1/cms/PaperSubject/bind_subject_tip", data);
// 更新试卷题目
export const updateExamQuestion = (data) => http.post("/v1/cms/PaperSubject/up_by_subject_tip", data);
